import React from "react";
import { Box, Container } from "@mui/material";

import { Forecast, ForecastPeriodData } from "../../../../api/models/Forecast";
import ForecastDataGrid, {
  TableRow,
} from "../ConsumptionForecasts/EditSample/ForecastDataGrid";
import ForecastLineChart from "../ConsumptionForecasts/EditSample/ForecastLineChart";
import { get15MinIntervalsForDate } from "../../../../helpers/timeIntervals";

interface MainContentProps {
  periodsData: ForecastPeriodData[];
  setPeriodsData: React.Dispatch<React.SetStateAction<ForecastPeriodData[]>>;
  setAverageLine: React.Dispatch<React.SetStateAction<number[]>>;
  setForecastLine: React.Dispatch<React.SetStateAction<number[]>>;
  tableMatrix: TableRow[];
  setTableMatrix: React.Dispatch<React.SetStateAction<TableRow[]>>;
  isEditable: boolean;
  forecast: Forecast;
  averageLine: number[];
  forecastLine: number[];
  hourlyForecast?: boolean;
}

const MainContent: React.FC<MainContentProps> = ({
  periodsData,
  setPeriodsData,
  setAverageLine,
  setForecastLine,
  tableMatrix,
  setTableMatrix,
  isEditable,
  forecast,
  averageLine,
  forecastLine,
  hourlyForecast,
}) => {
  const periods = get15MinIntervalsForDate(forecast.prognoseDate);

  return (
    <Container
      maxWidth="xl"
      sx={{
        background: "white",
        mt: "1rem",
        padding: "1rem",
        boxShadow: 2,
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        {periodsData && (
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <ForecastDataGrid
              prognoseValues={forecast?.prognoseValues}
              periodsData={periodsData}
              setPeriodsData={setPeriodsData}
              setAverageLine={setAverageLine}
              setForecastLine={setForecastLine}
              tableMatrix={tableMatrix}
              setTableMatrix={setTableMatrix}
              isEditable={isEditable}
              hourlyForecast={hourlyForecast}
              forecastDate={forecast.prognoseDate}
              forecastTemperatures={forecast?.forecastTemperatures}
              measuredTemperatures={forecast?.measuredTemperatures}
              temperatureMatches={forecast?.temperatureMatches}
            />
          </Box>
        )}

        <Box sx={{ position: "sticky", top: "4rem" }}>
          <ForecastLineChart
            periodsData={periodsData}
            averageLine={averageLine}
            forecastLine={forecastLine}
            tableMatrix={tableMatrix}
            hourlyForecast={hourlyForecast}
            xAxisLabels={periods}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default MainContent;
